import {Component, Inject, OnInit} from "@angular/core";
import {AppBarModule} from "@app/presentation/components/app-bar/app-bar.module";
import {TranslateModule} from "@ngx-translate/core";
import {
    AppStoreButtonComponent,
    AppStoreButtonType
} from "@app/presentation/components/app-store-button/app-store-button.component";
import {DIALOG_DATA, DialogRef} from "@angular/cdk/dialog";
import {EnvironmentPlatform} from "src/environments/environment-template";
import {DownloadAppModalViewModel} from "@app/presentation/services/download-app-modal/download-app-modal-view-model";

export interface DownloadAppModalComponentData {
    platform: EnvironmentPlatform;
}

@Component({
    standalone: true,
    selector: 'app-download-app-modal',
    templateUrl: './download-app-modal.component.html',
    styleUrl: './download-app-modal.component.scss',
    imports: [
        AppBarModule,
        TranslateModule,
        AppStoreButtonComponent
    ],
    providers: [
        DownloadAppModalViewModel,
    ]
})
export class DownloadAppModalComponent implements OnInit{

    constructor(
        private viewModel: DownloadAppModalViewModel,
        @Inject(DIALOG_DATA) private dialogData: DownloadAppModalComponentData,
        private dialogRef: DialogRef,
    ) {}

    ngOnInit() {
        this.dialogRef.closed.subscribe(() => {
            this.viewModel.notifyDownloadAppModalClosed();
        });
    }

    protected readonly appStoreButtonType = this.getStoreButtonType();

    private getStoreButtonType() {
        if (this.dialogData.platform === EnvironmentPlatform.AND) {
            return AppStoreButtonType.GOOGLE_PLAY;
        }
        if (this.dialogData.platform === EnvironmentPlatform.IOS) {
            return AppStoreButtonType.APP_STORE;
        }
        throw new Error('Platform not supported');
    }
}